import type { HeadCell, SelectOption } from '../../../../../components';
import { RecommendationLevel, type TickCellHeader } from './types';
import { PAGE_TEXT } from './lang';

export const ratingHeaderCells: Array<HeadCell<TickCellHeader>> = [
  {
    id: 'title',
    label: '',
    isSortable: false,
    render: (row: TickCellHeader) => row.title,
  },
  {
    id: 'EXCELLENT',
    label: PAGE_TEXT.level.EXCELLENT,
    isSortable: false,
    render: (row: TickCellHeader) => row.EXCELLENT,
  },
  {
    id: 'VERY_GOOD',
    label: PAGE_TEXT.level.VERY_GOOD,
    isSortable: false,
    render: (row: TickCellHeader) => row.VERY_GOOD,
  },
  {
    id: 'SATISFACTORY',
    label: PAGE_TEXT.level.SATISFACTORY,
    isSortable: false,
    render: (row: TickCellHeader) => row.SATISFACTORY,
  },
  {
    id: 'AVERAGE_OR_BELOW',
    label: PAGE_TEXT.level.AVERAGE_OR_BELOW,
    isSortable: false,
    render: (row: TickCellHeader) => row.AVERAGE_OR_BELOW,
  },
  {
    id: 'NO_BASIS_FOR_JUDGMENT',
    label: PAGE_TEXT.level.NO_BASIS_FOR_JUDGMENT,
    isSortable: false,
    render: (row: TickCellHeader) => row.NO_BASIS_FOR_JUDGMENT,
  },
];

export const selectOptions: SelectOption[] = [
  {
    label: 'Recommended very strongly',
    value: RecommendationLevel.VERY_HIGHLY_RECOMMENDED,
  },
  {
    label: 'Recommended strongly',
    value: RecommendationLevel.HIGHLY_RECOMMENDED,
  },
  {
    label: 'Recommended with reservation',
    value: RecommendationLevel.RECOMMENDED,
  },
  { label: 'Not recommended', value: RecommendationLevel.NOT_RECOMMENDED },
];
